import React from "react";
import { Link } from "gatsby";
// import Burger from "./burger";

const Navi = () => {
  const [active, setActive] = React.useState(false);
  return (
    <>
      <div className="nav-row">
        <Link to="/">
          <h2>
            <span className="span">Damian</span>Wilk
          </h2>
        </Link>
        <div className="links">
          <Link to="/" activeClassName="activeClassName">
            Home
          </Link>
          <Link to="/projects/" activeClassName="activeClassName">
            Projects
          </Link>
          <Link to="/about/" activeClassName="activeClassName">
            About
          </Link>
        </div>
        {/* Hamburger (Small screens) */}
        <button
          onClick={() => {
            setActive(!active);
          }}
          className={"hamburger hamburger--spring " + (active && "is-active")}
          type="button"
        >
          <span className="hamburger-box">
            <span className="hamburger-inner"></span>
          </span>
        </button>
      </div>
      {/* Renders when hamburger is active */}
      {active && (
        <div className="mobile-nav-zone">
          <div className="links-mobile">
            <Link to="/" activeClassName="activeClassName">
              Home
            </Link>
            <Link to="/projects/" activeClassName="activeClassName">
              Projects
            </Link>
            <Link to="/about/" activeClassName="activeClassName">
              About
            </Link>
          </div>
        </div>
      )}
    </>
  );
};

export default Navi;
